import { defineComponent, useCssVars, ref, onMounted, openBlock, createElementBlock, createBlock, unref, withCtx, createVNode, createElementVNode, Fragment, renderList, createCommentVNode } from "vue";
import { CdrSkeleton, CdrSkeletonBone } from "@rei/cedar";
const _hoisted_1 = {
  class: "loading-recommendations"
};
const _hoisted_2 = {
  class: "loading-recommendations__section"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "LoadingRecommendations",
  props: {
    cards: {
      default: 6
    },
    imgSize: {
      default: 150
    },
    timeout: {
      default: 5e3
    }
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "fb31f536": cardWidth.value,
      "36d10be5": minWidth.value
    }));
    const props = __props;
    const container = ref(null);
    const cardWidth = ref(`calc(100%/${props.cards}`);
    const minWidth = ref(`${props.imgSize}px`);
    const timedOut = ref(false);
    onMounted(() => setTimeout(() => {
      timedOut.value = true;
    }, props.timeout));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [!timedOut.value ? (openBlock(), createBlock(unref(CdrSkeleton), {
        key: 0,
        ref_key: "container",
        ref: container,
        class: "loading-recommendations__skeleton"
      }, {
        default: withCtx(() => [createVNode(unref(CdrSkeletonBone), {
          type: "line",
          class: "loading-recommendations__heading"
        }), createElementVNode("div", _hoisted_2, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.cards, (card) => {
          return openBlock(), createElementBlock("div", {
            key: card,
            class: "loading-recommendations__item"
          }, [createVNode(unref(CdrSkeletonBone), {
            type: "square",
            class: "loading-recommendations__img"
          }), createVNode(unref(CdrSkeletonBone), {
            type: "line"
          }), createVNode(unref(CdrSkeletonBone), {
            type: "line"
          }), createVNode(unref(CdrSkeletonBone), {
            type: "line"
          }), createVNode(unref(CdrSkeletonBone), {
            type: "line"
          })]);
        }), 128))])]),
        _: 1
      }, 512)) : createCommentVNode("", true)]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=LoadingRecommendations2.mjs.map
